import { useQuery } from '@tanstack/react-query'
import { fetchFunctionalCheckist } from '../services/fuctional_checklist'

const GetFunctionalChecklist = () => {
 const functionalChecklist = useQuery({
    queryKey:['functional_checklist'],
    queryFn: fetchFunctionalCheckist
 })
 return functionalChecklist;
}

export default GetFunctionalChecklist